module.exports = __webpack_public_path__ + "static/media/slack_workspace2.6c8e8a8a.png";